
$(".foo_title_btn1").click(function () {
    $("#fooNav").slideToggle();
    $("#caretDown").toggleClass("rotate");
});

$(".foo_title_btn2").click(function () {
    $("#fooContact").slideToggle();
    $("#caretDown2").toggleClass("rotate");
});

$("#subNavOne").click(function () {
    $(".sub_nav_items").slideToggle();
    $("#subNavOne img").toggleClass("rotate")
});


var swiper = new Swiper(".science-swiper", {
    spaceBetween: 100,
    loop: true,
    slidesPerView: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
        768: {
            slidesPerView: 1.2,
            spaceBetween: 0,
        }
    }
});


var swiper2 = new Swiper(".review-slider", {
    spaceBetween: 30,
    loop: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  breakpoints: {
        768: {
            spaceBetween: 80,
        }
    }
});


var swiper3 = new Swiper('.product-slider', {
    slidesPerView: 1.2,   
    loop: true,
    spaceBetween: 0,
  
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    centeredSlides: true,
    breakpoints: {
        768: {
            slidesPerView: 'auto',
        }
    },
    on: {
          init: function () {
            this.slideToLoop(0,1)
          }
    }
});

var swiper4= new Swiper(".our_product_slider", {
    slidesPerView: 1,
    spaceBetween: 80,
    loop: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 80,
        }
    }
}); 


var swiper5= new Swiper(".featured-products-items-container", {
    slidesPerView: 1,
    spaceBetween: 80,
    loop: true,   
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    navigation: {
        nextEl: '.featured-products-item-btn-next',
        prevEl: '.featured-products-item-btn-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 80,
        }
    }
}); 